import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import 'rxjs/add/operator/map';

@Injectable()
export class GeneralService {
  constructor(
    protected  http: Http,
  ) {
    // super(http);
  }

  revalidarCache (tag: string) {
    return this.http.get(`${ environment.SF_URL_V2 }api/revalidate?tag=${ tag }`)
      .map(res => {
        return res.json().data;
      });
  }

  revalidarPathCache (tag: string) {
    return this.http.get(`${ environment.SF_URL_V2 }api/revalidate?path=${ tag }`)
      .map(res => {
        return res.json().data;
      });
  }

  actualizarProductoEnEspecialDeMarca(id: number, categorias?: number[], status?: string) {
    return this.http.post(`${ environment.SF_API_V2 }/landing-pages/update/product/${ id }`, {categorias, status})
      .map(res => {
        return res.json().data;
      });
  }

  obtenerEstadoEspecialDeProducto(brandId: number, productId: number) {
    return this.http.get(`${ environment.SF_API_V2 }/landing-pages/brand/${ brandId }/product/${ productId }/status`)
      .map(res => {
        return res.json().data;
      });
  }

  // Safety-net cleanup: removes any landing page PRODUCT/PRODUCT_PRO elements
  // left pointing at a product that is no longer PUBLICADO. Meant to be called
  // after any operation that can change product status (manual edit, bulk
  // excel import, etc.) so especiales never show gaps for unavailable products.
  limpiarProductosDesactualizadosEnEspeciales() {
    return this.http.post(`${ environment.SF_API_V2 }/landing-pages/cleanup/stale-products`, {})
      .map(res => {
        return res.json().data;
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/general/general.service.ts